import type { ReactNode } from 'react';

export const symbol_circle_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.88-345q-55.88 0-95.38-39.32-39.5-39.33-39.5-95.5Q345-536 384.32-575q39.33-39 95.5-39Q536-614 575-574.88q39 39.12 39 95t-39.12 95.38q-39.12 39.5-95 39.5ZM324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM479.51-140q141.52 0 241-99Q820-338 820-479.51q0-141.52-99.49-241-99.48-99.49-241-99.49Q338-820 239-720.51q-99 99.48-99 241Q140-338 239-239t240.51 99Zm.49-340Zm137.5 137.95q56.5-57.06 56.5-138 0-80.95-56.5-137.45Q561-674 480.05-674q-80.94 0-138 56.5Q285-561 285-480.05q0 80.94 57.05 138 57.06 57.05 138 57.05 80.95 0 137.45-57.05Z"
		/>
	</svg>
);
